import React from 'react';

const RadioQuestion = ({ 
  question, 
  name, 
  options, 
  selectedValue, 
  onChange 
}) => {
  return (
    <div className="flex flex-col gap-4">
      {/* Dynamic Question */}
      <p className="text-grey-08 b3">{question}</p>
      
      {/* Dynamic Options */}
      <div className="flex flex-col gap-3">
        {options.map((option) => (
          <label key={option.value} className="flex items-center gap-2 cursor-pointer">
            <input 
              type="radio" 
              name={name} 
              value={option.value} 
              checked={selectedValue === option.value}
              onChange={(e) => onChange(e.target.value)}
              className="w-4.5 h-4.5 accent-purple-06 cursor-pointer" 
            />
            <span className="text-grey-06 b3">{option.label}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default RadioQuestion;